import React from 'react';
import GatsbyImage from 'gatsby-image';
import PropTypes from 'prop-types';

function TextWithImage({ image, children, reverse }) {
  function Image() {
    return (
      <div className={`${reverse ? 'order-first' : ''}`}>
        <div className="relative bg-light-pink">
          <GatsbyImage fluid={image} className="h-full" />
          <div aria-hidden className="absolute inset-0 flex p-4">
            <div aria-hidden className="flex-1 border border-white" />
          </div>
        </div>
      </div>
    );
  }
  return (
    <article className="px-4 py-6 sm:px-6 lg:px-8">
      <div className="grid w-full max-w-5xl gap-8 mx-auto md:grid-cols-2">
        <div className="flex flex-col text-white md:py-8">{children}</div>
        <Image />
      </div>
    </article>
  );
}

TextWithImage.propTypes = {
  children: PropTypes.node.isRequired,
  image: PropTypes.object.isRequired,
  reverse: PropTypes.bool,
};

export { TextWithImage };
